var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.time?'数据时间：'+_vm.time:''))])])}
var staticRenderFns = []

export { render, staticRenderFns }